import { getServiceProvider } from '@takeshape/service-providers';
import { avatars, logos } from '../assets';
import { createServiceProvider } from '../util';

export default createServiceProvider({
  ...getServiceProvider('petfinder'),
  hasConnectionStatus: false,
  defaultAuthenticationType: 'oauth2',
  defaultEndpoint: 'https://api.petfinder.com/v2/',
  avatarPath: avatars.petfinder,
  logoPath: logos.petfinder
});
